'use client';

import { FC } from 'react';
import { useAuth } from '@/context/auth.context';
import { useReviewAnswerJobs } from '@/context/review-answer-jobs.context';
import { useReviewsPageSelectionContext, useReviewsPageTransportContext } from '@/context/reviews-page.context';
import { ModalAnswerPickedProps } from '@/components/modal-answer-picked/modal-answer-picked.types';
import { useModalAnswerPickedController } from '@/components/modal-answer-picked/use-modal-answer-picked-controller';
import { ModalAnswerPickedView } from '@/components/modal-answer-picked/ModalAnswerPickedView';

export type ModalAnswerPicked = ModalAnswerPickedProps;

const ModalAnswerPicked: FC<ModalAnswerPickedProps> = (props) => {
    const { selectionSessionId, pickedReviews, setPickedReviews } = useReviewsPageSelectionContext();
    const { enqueueReviewSelectionMutation } = useReviewsPageTransportContext();
    const { accessToken } = useAuth();
    const { refetchActiveJobs } = useReviewAnswerJobs();

    const controller = useModalAnswerPickedController({
        ...props,
        accessToken,
        selection: {
            selectionSessionId,
            pickedReviews,
            setPickedReviews,
        },
        transport: {
            enqueueReviewSelectionMutation,
        },
        refetchActiveJobs,
    });

    return <ModalAnswerPickedView {...props} {...controller} />;
};

export default ModalAnswerPicked;
